import { FormControlLabel as MUIFormControlLabel } from '@mui/material';
import { withStyles } from '@mui/styles';
import Theme from 'App.theme';

const FormControlLabel = withStyles({
  root: {
    '& .MuiTypography-root': {
      fontFamily: Theme.font,
      fontSize: 14,
    },
  },
})(MUIFormControlLabel);

export default FormControlLabel;
